<script>
	import formBase from '@_system/components/base/form.vue'
	import formmain from '@_system/components/base/formmain.vue'
	import delivery from './lib/delivery.vue'
	import toolbar from './lib/toolbar.vue'
	import print from './lib/print.vue'
	import contract from './lib/contract.vue'
	export default {
		extends: formBase,
		name: 'saleorderForm',
		props: {

		},
		data() {
			return {
				formToolbarConfig: [{
					group: 'file',
					code: 'contract',
					title: '合同',
					disabled: true
				}],
				contractShow: false,
				printShow: false,
				mainForm: this,
				exportData: [],
				deliveryShow: false,
				weight: 0,
				province: 0,
				deliveryList: [],
			}

		},

		watch: {

		},
		computed: {

		},
		render(h) {
			this.$slots.plug = [
				<vxe-modal v-model={this.contractShow} width="80%" height="80%" title="合同预览" transfer show-close destroy-on-close>
					<contract id={this.id} name={this.name} mainForm={this.mainForm} />
				</vxe-modal>
			]
			return formBase.render.call(this, h)
		},
		created() {

		},
		mounted() {

		},
		methods: {
			setBoxForeingKey(foreingkey) {
				let $son_saleorder_goods = this.fApi.el('$son_saleorder_goods')
				if ($son_saleorder_goods.store.box) {
					$son_saleorder_goods.store.box.add.setForeingKey(foreingkey)
					$son_saleorder_goods.store.box.add.preLoadData()
				}
				let companyname = this.fApi.el('companyname')
				companyname.getBox().setForeingKey(foreingkey)
			},
			afterGet(res) {

				this.setBoxForeingKey({
					customerid: res.customerid,
					form: 'saleorder'
				})
			},
			toolbarClick(e) {
				if (e == 'contract') {
					let canprint = this.fApi.getValue('canprint')
					if (canprint) {
						this.contractShow = true
					} else {
						this.$message.error('暂无合同')
					}

				}

			},
			beforeFormCreate(rule) {
				rule.forEach((item) => {
					if (item.field == 'additionalcosts') {
						delete item.props.min

					}
				})
			},
			beforeRender(res) {
				for (let i in res) {
					if (i == 'rategrossprofit' || i == 'discount') {
						res[i] = parseInt(res[i])
					}
				}
			},
			//regestEvent(rule, fApi) {


			//},

			aftertabledelete(e) {
				switch (e.moduleName) {
					case 'saleorder_collection':
						var table = e.table
						var fullData = table.getTableData().fullData
						var collection = 0
						fullData.forEach((item) => {
							if (item.amount) {
								collection += parseFloat(item.amount)
							}
						})
						this.fApi.setValue('collection', parseFloat(collection).toFixed(4))
						break;
					case 'saleorder_goods':
						//this.rejectBoxData(e.obj, true)
						this.getCompute()
						break;
				}




			},
			tablefieldChange(e) {
				// let value = e.store.box.add.setFieldRemain(e.data.row, e.store.container.uniqueItem, 'num', 'num')
				// e.data.row.num = value
				// console.log(e)
				switch (e.moduleName) {
					case 'saleorder_collection':
						var table = e.table
						var fullData = table.getTableData().fullData
						var collection = 0
						fullData.forEach((item) => {
							if (item.amount) {
								collection += parseFloat(item.amount)
							}
						})
						this.fApi.setValue('collection', parseFloat(collection).toFixed(4))
						break;
					case 'saleorder_goods':
						this.getCompute()
						break;

				}

			},
			tableInsert(e) {
				if (e.moduleName == 'saleorder_goods') {

					e.obj.num = e.data.num
					// e.obj.nummin_system = 1
					// e.obj.nummax_system = e.data.num
				}
			},

			afterTableInsert(e) {
				if (e.moduleName == 'saleorder_goods') {
					//this.rejectBoxData(e.obj)
					this.getCompute()
				}
			},
			beforeBoxSubmit(e) {
				if (e.formCreateInject.field == "customercode" && e.ischange) {

					this.restForm()
				}
			},
			afterBoxSubmit(e) {
				// if (e.moduleName == 'customer') {
				// 	this.getDelivery()
				// 	this.setBoxForeingKey({
				// 		customerid: this.fApi.getValue('customerid'),
				// 		form: 'saleorder'
				// 	})
				// }
				if (e.moduleName == 'company') {
					this.taxChange()
				}

			},
			customercodeChange() {
				
				this.setBoxForeingKey({
					customerid: this.fApi.getValue('customerid'),
					form: 'saleorder'
				})
				this.parcelidChange()
			},
			provinceChange() {
				this.getDelivery()
			},
			parcelidChange() {
				let weight = this.fApi.getValue('weight')
				let parcelid = this.fApi.getValue('parcelid')
				let parceprice = null
				let price = 0
				weight = Math.ceil(weight * 1.1)

				this.deliveryList.forEach((item) => {
					if ((item.minweight <= weight && item.maxweight > weight && item.deliveryid == parcelid) || (
							item
							.minweight <= weight && !item
							.maxweight && item.deliveryid == parcelid)) {
						parceprice = item
					}
				})

				if (parceprice != null) {
					if (parceprice.price) {
						price = parceprice.price ? parceprice.price : 0
					} else {
						let firstweight = parceprice.firstweight ? parceprice.firstweight : 0
						let maxweightPrice = 0
						this.deliveryList.forEach((item) => {
							if (item.maxweight == firstweight && item.deliveryid == parcelid) {
								maxweightPrice = item.price ? item.price : 0
							}
						})
						price = parseFloat(maxweightPrice) + (parseFloat(weight) - parseFloat(firstweight)) * parseFloat(
							parceprice.afterweight)
					}
				}
				this.fApi.setValue('freight', price)
				// let table = this.fApi.el('$son_saleorder_goods')
				// this.getTotalPrice(table)
			},
			getDelivery() {
				let province = this.fApi.getValue('province')
				if (province) {
					this.$api.parcel.listCheck({
						target: province[0],
					}).then((res) => {
						this.deliveryList = res
						this.parcelidChange()
					})
				}
			},

			getCompute() {
				let table = this.fApi.el('$son_saleorder_goods')
				let tableData = table.getTableData().tableData
				tableData.forEach((row) => {
					// let platform = this.fApi.el('platform')
					// let platformtax = platform.getCodeByValue(this.fApi.getValue('platform'))
					// platformtax = platformtax ? parseFloat(platformtax) : 0
					// let tax = this.fApi.getValue('tax') ? parseFloat(this.fApi.getValue('tax')) : 0
					// let pretaxfreight = row.pretaxfreight
					// let taxfreight = pretaxfreight * ((100 + tax + platformtax) / 100)
					// row.taxfreight = parseFloat(taxfreight).toFixed(4)

					row.preamount = (parseFloat(row.pretaxfreight) * parseInt(row.num)).toFixed(4)
					row.amount = (parseFloat(row.taxfreight) * parseInt(row.num)).toFixed(4)
				})
				this.$nextTick(() => {
					this.getTotalPrice(table)
					this.getTotalWeight(table)
					this.getTotalNumber(table)
				})

			},
			platformChange() {
				this.getCompute()

			},
			freightChange() {
				this.getCompute()
			},
			freighttaxChange() {
				this.getCompute()
			},
			additionalcostsChange(e) {
				let table = this.fApi.el('$son_saleorder_goods')
				let tableData = table.getTableData().tableData
				let price = 0
				tableData.forEach((row) => {
					if (row.bida) {
						price += parseFloat(row.taxfreight) * parseInt(row.num)
					}
				})
				this.fApi.setValue('price', (parseFloat(price) + parseFloat(e)).toFixed(4))


			},
			taxChange() {
				this.getCompute()
			},
			getTotalPrice(table) {

				let pretotalPrice = 0
				let totalPrice = 0
				let totalBid = 0
				let rategrossprofit = 0
				let profit = 0
				let freight = this.fApi.getValue('freight') ? this.fApi.getValue('freight') : 0
				let freighttax = this.fApi.getValue('freighttax') ? this.fApi.getValue('freighttax') : 0
				let additionalcosts = this.fApi.getValue('additionalcosts') ? this.fApi.getValue('additionalcosts') : 0

				let tableData = table.getTableData().tableData
				tableData.forEach((row) => {
					pretotalPrice += parseFloat(row.pretaxfreight) * parseInt(row.num ? row.num : 0)
					totalPrice += parseFloat(row.taxfreight) * parseInt(row.num ? row.num : 0)
					totalBid += parseFloat(row.bida) * parseInt(row.num)
				})
				totalPrice = parseFloat(totalPrice) + parseFloat(additionalcosts)
				totalBid = totalBid + parseFloat(freight) + parseFloat(freighttax)
				profit = pretotalPrice - totalBid
				if (profit == 0) {
					rategrossprofit = 0
				} else {
					rategrossprofit = profit / pretotalPrice * 100
				}

				this.fApi.setValue('price', parseFloat(totalPrice).toFixed(4))
				this.fApi.setValue('pretaxprice', parseFloat(pretotalPrice).toFixed(4))
				this.fApi.setValue('bid', parseFloat(totalBid).toFixed(4))
				this.fApi.setValue('rategrossprofit', parseFloat(rategrossprofit).toFixed(2))
				this.fApi.setValue('profit', parseFloat(profit).toFixed(4))
			},
			getTotalNumber(table) {
				let totalNumber = 0;
				let tableData = table.getTableData().tableData
				tableData.forEach((row) => {
					totalNumber += parseInt(row.num)
				})
				this.fApi.setValue('num', totalNumber)
			},
			getTotalWeight(table) {
				let totalWeight = 0;
				let tableData = table.getTableData().tableData
				if (tableData.length == 0) {
					totalWeight = 0
				} else {
					tableData.forEach((row) => {
						totalWeight += parseFloat(row.goodsweight ? row.goodsweight : 0) * parseInt(row.num)
					})
				}
				this.fApi.setValue('weight', totalWeight.toFixed(6))
				//this.parcelidChange()
			}

		},
		components: {
			formmain,
			delivery,
			toolbar,
			print,
			contract
		}
	}
</script>
